import ENDPOINTS from 'api/endpoints';
import { doGet, doPatch, doPost } from 'api/request';
import type {
  CustomMetricsImportResponse,
  CustomMetricsResponse,
  PatchCustomMetricsRequest,
  PostCustomMetricsRequest,
} from 'api/resources/customMetrics/types';
import { ImportFileType } from 'api/resources/customMetrics/types';
import { LOGGER_TYPE } from 'api/types';
import { generateNextPath } from 'lib/routeHelper';

export const getCustomMetrics = (accountId: string, projectId: string) => {
  return doGet<CustomMetricsResponse[]>(
    generateNextPath(ENDPOINTS.CUSTOM_METRICS, { accountId, projectId }),
    LOGGER_TYPE.JUPITER,
  );
};

export const createCustomMetric = (
  accountId: string,
  projectId: string,
  body: PostCustomMetricsRequest,
) => {
  return doPost<CustomMetricsResponse>(
    generateNextPath(ENDPOINTS.CUSTOM_METRICS, { accountId, projectId }),
    LOGGER_TYPE.JUPITER,
    body,
  );
};

export const patchCustomMetric = (
  accountId: string,
  projectId: string,
  metricName: string,
  body: PatchCustomMetricsRequest,
) => {
  return doPatch<CustomMetricsResponse>(
    generateNextPath(ENDPOINTS.CUSTOM_METRIC, {
      accountId,
      projectId,
      metricName,
    }),
    LOGGER_TYPE.JUPITER,
    body,
  );
};

export const importCustomMetrics = (
  accountId: string,
  projectId: string,
  file: File,
  dryRun: boolean = true,
  fileType: ImportFileType = ImportFileType.YAML,
) => {
  const bodyFormData = new FormData();
  const blob = new Blob([file], { type: fileType });
  bodyFormData.append(fileType, blob);

  return doPost<CustomMetricsImportResponse>(
    generateNextPath(
      ENDPOINTS.CUSTOM_METRICS_IMPORT,
      { accountId, projectId },
      { type: fileType, dry_run: `${dryRun}` },
    ),
    LOGGER_TYPE.JUPITER,
    bodyFormData,
    {
      postingFile: true,
      parseResponseToJSON: true,
    },
  );
};

export const exportCustomMetrics = (accountId: string, projectId: string) => {
  return doGet<Blob>(
    generateNextPath(ENDPOINTS.CUSTOM_METRICS_EXPORT, { accountId, projectId }),
    LOGGER_TYPE.JUPITER,
    {
      downloadingFile: true,
    },
  );
};
